var _style, _rect, _rect2, _path, _polygon, _path2, _path3, _rect3, _rect4, _path4, _path5, _rect5, _path6, _path7, _rect6, _path8, _path9, _path10, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9CC3D5;}\n\t.st1{fill:#ACC8D5;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#63BCE7;}\n\t.st4{fill:#04B354;}\n\t.st5{fill:#9E9E9E;}\n\t.st6{fill:#F7C98D;}\n\t.st7{fill:#E1C783;}\n\t.st8{fill:#6C777A;}\n\t.st9{fill:#91B5CA;}\n\t.st10{fill:#F8AF23;}\n\t.st11{fill:#3F3679;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 15.6,
    className: "st0",
    width: 137.8,
    height: 213.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 15.6,
    className: "st1",
    width: 15.5,
    height: 213.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.8,31H129c5.5,0,10,4.5,10,10v69.2c0,5.5-4.5,10-10,10H59.8c-5.5,0-10-4.5-10-10V41 C49.8,35.5,54.3,31,59.8,31z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "66.2,62.6 94.4,39.3 122.6,62.6 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.6,62.6h63.6c1.5,0,2.8,1.2,2.8,2.8l0,0c0,1.5-1.2,2.8-2.8,2.8H62.6c-1.5,0-2.8-1.2-2.8-2.8l0,0 C59.9,63.9,61.1,62.6,62.6,62.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.2,68.1h9.4l0,0v6.9c0,0.5-0.4,0.8-0.8,0.8h0h-7.7c-0.5,0-0.8-0.4-0.8-0.8v0L66.2,68.1L66.2,68.1L66.2,68.1z "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.4,
    y: 75.9,
    className: "st5",
    width: 5.1,
    height: 20.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9,
    y: 104,
    className: "st3",
    width: 63,
    height: 7.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.6,104h-9.4l0,0v-6.9c0-0.5,0.4-0.8,0.8-0.8h0h7.7c0.5,0,0.8,0.4,0.8,0.8v0L75.6,104L75.6,104z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89.7,68.1h9.4l0,0v6.9c0,0.5-0.4,0.8-0.8,0.8h0h-7.7c-0.5,0-0.8-0.4-0.8-0.8v0L89.7,68.1L89.7,68.1z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 75.9,
    className: "st5",
    width: 5.1,
    height: 20.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.1,104h-9.4l0,0v-6.9c0-0.5,0.4-0.8,0.8-0.8h0h7.7c0.5,0,0.8,0.4,0.8,0.8v0L99.1,104L99.1,104L99.1,104z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.3,68.1h9.4l0,0v6.9c0,0.5-0.4,0.8-0.8,0.8h0h-7.7c-0.5,0-0.8-0.4-0.8-0.8v0L113.3,68.1L113.3,68.1z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 75.9,
    className: "st5",
    width: 5.1,
    height: 20.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.6,104h-9.4l0,0v-6.9c0-0.5,0.4-0.8,0.8-0.8h0h7.7c0.5,0,0.8,0.4,0.8,0.8v0L122.6,104L122.6,104z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M163.3,26.8V74l-9.3-10.9c-3.9-4.5-10.7-5.1-15.2-1.2l0,0c-4.5,3.9-5.1,10.7-1.2,15.2l21.1,24.8 c0,0-6.3,26.6,10.3,41.8h47l-4.2-57.1c-0.5-5.3-3.8-9.7-7.1-13.4L163.3,26.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M211.9,86.5c-0.5-5.3-3.8-9.7-7.1-13.4l-41.5-46.3v17.3l26,29c3.3,3.7,6.6,8.2,7.1,13.4l4.2,57.1H216 L211.9,86.5z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148.3,
    y: 143.6,
    className: "st8",
    width: 82.2,
    height: 29.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 143.6,
    className: "st0",
    width: 15.5,
    height: 29.2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 153.2,
    y: 172.8,
    className: "st1",
    width: 72.5,
    height: 56.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 210.1,
    y: 172.8,
    className: "st9",
    width: 15.5,
    height: 56.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8,
    y: 136.7,
    className: "st10",
    width: 89.2,
    height: 14
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8,
    y: 160.6,
    className: "st10",
    width: 89.2,
    height: 14
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 49.8,
    y: 184.4,
    className: "st10",
    width: 89.2,
    height: 14
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M27.3,238.9h-18c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h18c0.8,0,1.5-0.7,1.5-1.5S28.2,238.9,27.3,238.9 L27.3,238.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M246.7,238.9h-18c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h18c0.8,0,1.5-0.7,1.5-1.5S247.5,238.9,246.7,238.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M218.5,238.9h-181c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h181c0.8,0,1.5-0.7,1.5-1.5S219.3,238.9,218.5,238.9 z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M248.2,229.4c0-0.8-0.7-1.5-1.5-1.5h-19.6v-53.6h3.4c0.8,0,1.5-0.7,1.5-1.5v-29.2c0-0.8-0.7-1.5-1.5-1.5h-13.1 l-4.1-55.8c-0.6-5.9-4.3-10.8-7.4-14.3l-41.1-45.8V15.6c0-0.8-0.7-1.5-1.5-1.5H25.5c-0.8,0-1.5,0.7-1.5,1.5v212.4H9.3 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h237.4C247.5,230.9,248.2,230.3,248.2,229.4z M229,171.3h-79.2v-9.2h45.9 c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-45.9v-13.9H229V171.3z M165.5,142.1h-0.7v-0.8C165.1,141.6,165.3,141.9,165.5,142.1z  M203.7,74.1c2.9,3.2,6.2,7.5,6.7,12.5l4,55.5h-44.8c-15.2-14.5-9.5-39.7-9.4-40c0.1-0.5,0-1-0.3-1.3l-21.1-24.8 c-3.3-3.9-2.9-9.8,1-13.1c3.9-3.3,9.8-2.9,13.1,1l9.3,10.9l17.6,20.7c0.5,0.6,1.5,0.7,2.1,0.1c0.6-0.5,0.7-1.5,0.2-2.1l-17.3-20.3 V30.7L203.7,74.1z M137.5,61c-4.8,4.5-5.3,12-1,17l1,1.2v31c0,4.7-3.8,8.5-8.5,8.5H59.8c-4.7,0-8.5-3.8-8.5-8.5V41 c0-4.7,3.8-8.5,8.5-8.5H129c4.7,0,8.5,3.8,8.5,8.5V61z M27,17.1h134.8v52.8l-6.6-7.8c-3.6-4.2-9.6-5.5-14.7-3.1V41 c0-6.3-5.2-11.5-11.5-11.5H59.8c-6.3,0-11.5,5.2-11.5,11.5v69.2c0,6.3,5.2,11.5,11.5,11.5H129c6.3,0,11.5-5.2,11.5-11.5V82.8 l16.6,19.5c-0.9,4.9-1.2,9.9-1,14.9c0.3,7,2.2,13.8,5.7,19.9c0,0,0,0,0,0.1v5h-13.6c-0.8,0-1.5,0.7-1.5,1.5v29.2 c0,0.8,0.7,1.5,1.5,1.5h3.4v53.6H27V17.1z M163.3,227.9h-8.7v-53.6h69.5v53.6H163.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M126.2,61.1h-3l-27.8-23c-0.6-0.5-1.4-0.5-1.9,0l-27.8,23h-3c-2.4,0-4.3,1.9-4.3,4.3c0,2.3,1.9,4.3,4.3,4.3 h2.1v5.4c0,1.2,1,2.3,2.2,2.3v17.4c-1.2,0.1-2.2,1.1-2.2,2.3v5.4h-1.8c-0.8,0-1.5,0.7-1.5,1.5v7.9c0,0.8,0.7,1.5,1.5,1.5h63 c0.8,0,1.5-0.7,1.5-1.5V104c0-0.8-0.7-1.5-1.5-1.5h-1.8v-5.4c0-1.2-0.9-2.2-2-2.3V77.4c1.2-0.1,2-1.1,2-2.3v-5.4h2.1 c2.4,0,4.3-1.9,4.3-4.3C130.5,63,128.6,61.1,126.2,61.1z M94.4,41.2l24,19.9H70.4L94.4,41.2z M88.2,69.6v5.4c0,1.2,1,2.3,2.2,2.3 v17.4c-1.2,0.1-2.2,1.1-2.2,2.3v5.4H77.1v-5.4c0-1.2-0.9-2.2-2-2.3V77.4c1.2-0.1,2-1.1,2-2.3v-5.4H88.2z M111.8,69.6v5.4 c0,1.2,1,2.3,2.2,2.3v17.4c-1.2,0.1-2.2,1.1-2.2,2.3v5.4h-11.1v-5.4c0-1.2-0.9-2.2-2-2.3V77.4c1.2-0.1,2-1.1,2-2.3v-5.4H111.8z  M119.1,94.8H117V77.4h2.1V94.8z M95.6,94.8h-2.1V77.4h2.1V94.8z M91.2,97.8h6.4v4.8h-6.4V97.8z M97.6,74.4h-6.4v-4.8h6.4V74.4z  M69.9,77.4H72v17.4h-2.1V77.4z M74.1,74.4h-6.4v-4.8h6.4L74.1,74.4z M67.7,97.8h6.4v4.8h-6.4V97.8z M124.4,110.5h-60v-4.9h60 L124.4,110.5z M114.8,102.5v-4.8h6.4v4.8H114.8z M121.1,74.4h-6.4v-4.8h6.4V74.4z M126.2,66.6H62.6c-0.7,0-1.3-0.6-1.3-1.3 c0-0.7,0.6-1.3,1.3-1.3h63.6c0.7,0,1.3,0.6,1.3,1.3C127.5,66.1,126.9,66.6,126.2,66.6L126.2,66.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M206.3,159.1c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h9.8c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5H206.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M139,135.2H49.8c-0.8,0-1.5,0.7-1.5,1.5v14c0,0.8,0.7,1.5,1.5,1.5H139c0.8,0,1.5-0.7,1.5-1.5v-14 C140.5,135.9,139.9,135.2,139,135.2z M137.5,149.2H51.3v-11h86.2V149.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M139,159.1H49.8c-0.8,0-1.5,0.7-1.5,1.5v14c0,0.8,0.7,1.5,1.5,1.5H139c0.8,0,1.5-0.7,1.5-1.5v-14 C140.5,159.8,139.9,159.1,139,159.1z M137.5,173.1H51.3v-11h86.2V173.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M139,182.9H49.8c-0.8,0-1.5,0.7-1.5,1.5v14c0,0.8,0.7,1.5,1.5,1.5H139c0.8,0,1.5-0.7,1.5-1.5v-14 C140.5,183.6,139.9,182.9,139,182.9z M137.5,196.9H51.3v-11h86.2V196.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M70.2,214.3H49.8c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h20.4c0.8,0,1.5-0.7,1.5-1.5S71.1,214.3,70.2,214.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalLoan);
export default __webpack_public_path__ + "static/media/personalLoan.9bcdb9f2285d9138bb5e0998aca602f1.svg";
export { ForwardRef as ReactComponent };